import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageHeaderComponent } from './image-header.component';
import { RouterModule } from '@angular/router';
import { DisableClickEventModule } from '~app/modules/storyblok/directives/disable-click-event/disable-click-event.module';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';

@NgModule({
  declarations: [ImageHeaderComponent],
  imports: [CommonModule, RouterModule, DisableClickEventModule, IsVisibleModule],
  exports: [ImageHeaderComponent],
})
export class ImageHeaderModule {}
